import Vue from 'vue'

import * as types from './mutation-types'
import { storageNames } from '@/assets/js/const'

const mutations = {
  [types.SET_ALREADY_WALLET_CONNECTED] (state, result) {
    state.alreadyWalletConnected = result;
    console.log('ccc', result)
    Vue.ls.set(storageNames.alreadyWalletConnected, result)
  }
}

export default mutations